import { z } from 'zod';
import Papa from 'papaparse';
import type { QuestionOption } from '@aphp-ema/common/questionnaire';
import { detectFileEncoding } from '@/shared/utils/csv';

const QuestionOptionCsvRowSchema = z.object({
  LIBELLE: z
    .string()
    .min(1, { message: 'Label is required and cannot be empty' }),
});

const QuestionOptionCsvDataSchema = z.array(QuestionOptionCsvRowSchema);

type ParseCSVResult = {
  fileName: string;
  options: QuestionOption[];
};

export const parseQuestionOptionsCsv = async (
  file: File,
): Promise<ParseCSVResult> => {
  // Read file as ArrayBuffer for encoding detection
  const buffer = await file.arrayBuffer();
  const detectionResult = detectFileEncoding(buffer);

  if (!detectionResult.success) {
    throw new Error('ENCODING_DETECTION_FAILED');
  }

  // Parse the properly decoded text with Papa Parse
  return new Promise((resolve, reject) => {
    Papa.parse(detectionResult.text, {
      header: true,
      delimiter: ';',
      skipEmptyLines: true,
      complete: (results) => {
        const validationResult = QuestionOptionCsvDataSchema.safeParse(
          results.data,
        );

        if (!validationResult.success) {
          reject('INVALID_CSV_DATA');
        } else {
          const options: QuestionOption[] = validationResult.data.map(
            (row) => ({
              label: row.LIBELLE,
            }),
          );

          resolve({
            options,
            fileName: file.name,
          });
        }
      },
      error: () => {
        reject('UNEXPECTED_ERROR');
      },
    });
  });
};
